import React from "react";
import "./Fasilitas.css";
import imgFasilitas from "../../assets/fasilitas/fasilitas (1).webp";
import checkIcon from "../../assets/sec_benefit_sc/icon_check.webp";

const Fasilitas = () => {
  const currentYear = new Date().getFullYear();
const previousYear = currentYear - 1;

  return (
    <React.Fragment>
      <div className="container-fasilitas">
        <img src={imgFasilitas} alt="Les Persiapan Masuk Bintara TNI Polri" className="img-fasilitas" />
        <div className="text-fasilitas">
          <h1 className="title-fasilitas">
            FASILITAS TRAINING <br /> SUPER LENGKAP
          </h1>
          <p className="desk-fasilitas">
            Venue karantina dengan penginapan yang nyaman dan lengkap serta
            fasilitas pendukung belajar dan latihan yang memadai dan sesuai
            standar.
          </p>
        </div>
      </div>

      {/* LOKASI KARANTINA */}
      <div className="container-lokasi">
        <h1 className="title-lokasi">Lokasi Karantina</h1>
        <span className="list-fasilitas-tc">
          <img src={checkIcon} alt="Les Persiapan Masuk Bintara TNI Polri" className="icon-check" />
          Asrama Edumatrix Indonesia dekat Tugu Yogyakarta.
        </span>
        <h1 className="title-waktu">Waktu Karantina</h1>
        <span className="list-fasilitas-tc">
          <img src={checkIcon} alt="Les Persiapan Masuk Bintara TNI Polri" className="icon-check" />
          November {previousYear} - Mei {currentYear}.
        </span>
      </div>
    </React.Fragment>
  );
};

export default Fasilitas;
